import { styled } from '@mui/material/styles';
import { Rating } from '@mui/material';

export const StyledRating = styled(Rating)({
  '& .MuiRating-icon': {
    border: '1px',
  },
  '& .MuiRating-iconFilled': {
    color: '#5ECAEC',
  },
  '& .MuiRating-iconEmpty': {
    color: '#C9D0DA',
  },
});
